import { useCallback, useEffect, useState } from 'react'
import type { CrmLeadCardInFunnelData } from '@/api/types/crm/crmFunnels.types'
import {
  EMPTY_DEAL_UTM,
  normalizeDealUtm,
  type DealUtm,
  type DealUtmKey,
} from './dealUtm.utils'

export function useLeadProfileDealUtm(params: {
  multipleDealsEnabled: boolean
  selectedFunnelId: number | null
  selectedLeadFunnelId: number | null
  cardFunnelSnapshotEpoch: number
  getCardInFunnelSnapshot: (
    funnelId: number,
    leadFunnelId?: number | null,
  ) => CrmLeadCardInFunnelData | undefined
}) {
  const {
    multipleDealsEnabled,
    selectedFunnelId,
    selectedLeadFunnelId,
    cardFunnelSnapshotEpoch,
    getCardInFunnelSnapshot,
  } = params

  const [dealUtmDraft, setDealUtmDraft] = useState<DealUtm>(EMPTY_DEAL_UTM)
  const [committedDealUtm, setCommittedDealUtm] =
    useState<DealUtm>(EMPTY_DEAL_UTM)

  useEffect(() => {
    if (!multipleDealsEnabled || selectedFunnelId == null) {
      setDealUtmDraft(EMPTY_DEAL_UTM)
      setCommittedDealUtm(EMPTY_DEAL_UTM)
      return
    }

    const snap = getCardInFunnelSnapshot(selectedFunnelId, selectedLeadFunnelId)
    if (!snap && selectedLeadFunnelId != null) {
      // Снимок ещё от другой сделки / не загружен — ждём refetch.
      return
    }

    const next = normalizeDealUtm(snap?.utm)
    setCommittedDealUtm(next)
    setDealUtmDraft(next)
  }, [
    multipleDealsEnabled,
    selectedFunnelId,
    selectedLeadFunnelId,
    cardFunnelSnapshotEpoch,
    getCardInFunnelSnapshot,
  ])

  const handleChangeDealUtmField = useCallback(
    (key: DealUtmKey, value: string) => {
      setDealUtmDraft((prev) => ({
        ...prev,
        [key]: value,
      }))
    },
    [],
  )

  const resetDealUtmDraft = useCallback(() => {
    setDealUtmDraft(committedDealUtm)
  }, [committedDealUtm])

  return {
    dealUtmDraft,
    committedDealUtm,
    handleChangeDealUtmField,
    resetDealUtmDraft,
  }
}
